const speakers = (state = {}, action) => {
    switch (action.type) {
        case 'SPEAKERS_DATA_LOADED' : 
            return{
            ...state,
            speakersData : action.payload
            }
        default:
            return state
        }
  }
  export default speakers